export default function getCountryNameByCode(code) {
  const countryCodes = {
    "+91": "India",
    "+1": "United States",
    "+44": "United Kingdom",
    "+61": "Australia",
    "+81": "Japan",
    "+49": "Germany",
    // Add more as needed
  };

  return countryCodes[code] || "Unknown Country";
}
